import ActivityTimeline from "../../components/ActivityTimeline/ActivityTimeline";
import React from "react";

const ActivityTimelinePage = () => {
  return (
    <div className="full-sec"><div className="activity-timeline right-sec">
        <ActivityTimeline />
      </div>
    </div>
  );
};

export default ActivityTimelinePage;
